var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    [
      _c("AdminNavMenu", { attrs: { activeItem: "main" } }),
      _vm._v(" "),
      _c("AdminCategories"),
      _vm._v(" "),
      _c("AdminProducts"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }